import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableBranchRoutes = Loadable(
  './BranchRoutes',
  () => import(/* webpackChunkName: "Branch" */ './BranchRoutes'),
  () => [(require as any).resolveWeak('./BranchRoutes')]
);
